export default "__VITE_ASSET__D$lEdbcC__"